import { render, staticRenderFns } from "./ProjectClientEdit.vue?vue&type=template&id=a26220cc&scoped=true"
import script from "./ProjectClientEdit.vue?vue&type=script&lang=js"
export * from "./ProjectClientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26220cc",
  null
  
)

export default component.exports